'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import SplideSlider from '@components/SplideSlider';
import CustomImage from '@components/CustomImage';
import cn from './style.module.scss';
export default function OgamiIntroduction(props: MarketingPageComponentProps) {
  const introductionSection = props?.locale?.section?.find(
    (section: any) => section.type === 'introduction' && section.enabled
  );
  if (!introductionSection) return null;
  const ogamiIntroductionSliderElement =
    introductionSection?.ogamiIntroductionSlider || [];
  const OgamiIntroductionSlideSettings = {
    type: 'fade',
    rewind: true,
    autoplay: true,
    speed: 2000,
    interval: 6000,
  };
  return (
    <Stack component="section" className={cn.ogamiIntroductionWrapper}>
      <Box className={cn.ogamiIntroductionInner}>
        <Box className={cn.ogamiIntroductionBlock}>
          <Box className={cn.ogamiIntroductionContent}>
            <Box className={cn.ogamiIntroductionContent__title}>
              <ParallaxText
                variant="h2"
                animationType="zoomIn"
                animationDuration={500}
              >
                {ReactHtmlParser(introductionSection?.ogamiIntroductionHeading)}
              </ParallaxText>
            </Box>
            <Box className={cn.ogamiIntroductionContent__data}>
              {introductionSection?.ogamiIntroductionContent?.map(
                (content: string, index: number) => (
                  <ParallaxText
                    key={index}
                    variant="p"
                    animationType="zoomIn"
                    animationDuration={500}
                  >
                    {ReactHtmlParser(content)}
                  </ParallaxText>
                )
              )}
            </Box>
          </Box>
          <Box className={cn.ogamiIntroductionTheme}>
            <Box className={cn.introductionThemeBlock}>
              <SplideSlider options={OgamiIntroductionSlideSettings}>
                {ogamiIntroductionSliderElement.map(
                  (item: any, index: number) => (
                    <Box
                      key={item.url ?? index}
                      className={cn.ogamiIntroductionStory}
                    >
                      <CustomImage
                        src={item.url}
                        alt={item.alt ?? `slider-image-${index}`}
                        width={1200}
                        height={800}
                      />
                    </Box>
                  )
                )}
              </SplideSlider>
            </Box>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
